module.exports = __webpack_public_path__ + "media/logos/forbes-logo-black-12ad03ab.png";